export const ENCODING = {
    QUOTED_PRINTABLE: 'quoted-printable',
    URI: 'uri',
    INTEGER: 'integer',
    FLOAT: 'float',
    BOOLEAN: 'boolean',
    DATE_TIME: 'date-time',
    TIMESTAMP: 'timestamp',
    DATE: 'date',
    TIME: 'time',
    UTC_OFFSET: 'utc-offset',
};

export const TYPE = {
    WORK: 'work',
    HOME: 'home',
};

export const VERSION = '4.0';
export const FN = 'fn';
export const N = 'n';
export const ORG = 'org';
export const ADR = 'adr';
export const NICKNAME = 'nickname';
export const BDAY = 'bday';
export const ANNIVERSARY = 'anniversary';
export const LANGUAGE = 'lang';
export const GENDER = 'gender';
export const GEO = 'geo';
export const PHOTO = 'photo';
export const LOGO = 'logo';
export const URI = 'uri';
export const IMPP = 'impp';
export const CLIENTPIDMAP = 'clientpidmap';
export const TZ = 'tz';
export const TITLE = 'title';
export const ROLE ='role';
export const MEMBER ='member';
export const RELATED ='related';
export const CATEGORIES ='categories';

// Not considered by parser yet
export const BIRTHPLACE = 'birthplace'
export const DEATHDATE = 'deathdate'
export const DEATHPLACE = 'deathplace'
export const EXPERTISE = 'expertise'
export const HOBBY = 'hobby'
export const INTEREST = 'interest'
export const KIND = 'kind'
export const XML = 'xml'
export const ORGDIRECTORY = 'org-directory'

export const VERSION_PROP = 'VERSION';
export const BEGIN_VCARD = 'BEGIN:VCARD';
export const END_VCARD = 'END:VCARD';